import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { SchedulerClient, SchedulerView } from './reporting-api-proxies';

@Injectable({
    providedIn: 'root'
})
export class SchedulerService {
    constructor(private readonly client: SchedulerClient) {}

    async getById(id: number): Promise<SchedulerView> {
        return await lastValueFrom(this.client.schedulerGetSchedulerById(id));
    }

    async archive(body: number): Promise<void> {
        return await lastValueFrom(this.client.schedulerArchiveScheduler(body));
    }

    async changeState(body: number): Promise<number> {
        return await lastValueFrom(this.client.schedulerChangeStateScheduler(body));
    }

    async save(body: SchedulerView): Promise<SchedulerView> {
        return await lastValueFrom(this.client.schedulerSave(body));
    }
}
